// HCO/HCP admin-defined custom fields (backend: CustomFieldsController / CustomFieldService).

export enum CustomFieldDataType {
  Text = 1,
  Number = 2,
  Boolean = 3,
  Date = 4,
  SingleChoice = 5,
  MultipleChoice = 6
}

export const CUSTOM_FIELD_TYPES: { id: CustomFieldDataType, name: string }[] = [
  { id: CustomFieldDataType.Text, name: 'Text' },
  { id: CustomFieldDataType.Number, name: 'Number' },
  { id: CustomFieldDataType.Boolean, name: 'Yes / No (checkbox)' },
  { id: CustomFieldDataType.Date, name: 'Date' },
  { id: CustomFieldDataType.SingleChoice, name: 'Single choice' },
  { id: CustomFieldDataType.MultipleChoice, name: 'Multiple choice' }
];

export interface CustomFieldOption {
  id: number;
  value: string;
  isActive: boolean;
  sortOrder: number;
  isUsed?: boolean;
}

export interface CustomField {
  id: number;
  name: string;
  dataType: CustomFieldDataType;
  appliesToHco: boolean;
  appliesToHcp: boolean;
  isActive: boolean;
  isRequired: boolean;
  sortOrder: number;
  options: CustomFieldOption[];
  hasHcoValues?: boolean;
  hasHcpValues?: boolean;
}

/** One value on an HCO/HCP. Send only fieldId + value; an empty value clears it. */
export interface CustomFieldValue {
  fieldId: number;
  value: string;
  displayValue?: string;
}

export function isChoiceType(type: CustomFieldDataType): boolean {
  return type === CustomFieldDataType.SingleChoice || type === CustomFieldDataType.MultipleChoice;
}
